export class Meta {
  init() {
    this.createBreadcrumbSchema();
  }

  createBreadcrumbSchema() {
    const scriptTag = document.createElement('script');

    scriptTag.setAttribute('type', 'application/ld+json');

    const breadCrumbs = location.pathname.slice(1, -1).split('/');
    const itemListElement = [];

    breadCrumbs.forEach((value, idx, array) => {
      const listItem = {
        "@type": "ListItem",
        "position": idx + 1,
        "item": {}
      };
      let path = window.origin + '/';

      for (let i = 0; i <= idx; i++) {
          path += `${breadCrumbs[i]}/`;
      }
      listItem["item"]["@id"] = path;

      if (['en', 'pl', 'de'].includes(value) || !['en', 'pl', 'de'].includes(array[0])) {
        listItem["item"]["name"] = 'Homepage';
      } else {
        listItem["item"]["name"] = (value[0].toUpperCase() + value.slice(1)).replace(/-/g, ' ');
      }

      itemListElement.push(listItem);
    });

    const data = {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      "itemListElement":
        [...itemListElement]
    };

    scriptTag.innerHTML = JSON.stringify(data);

    document.head.append(scriptTag);
  }
}
